import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Global } from '../global';
import { EnvService } from 'src/app/env.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private env: EnvService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    Global.isInMaintenanceMode = false;
    return next.handle(request).pipe(
      catchError((err) => {
        if (!this.env.production) {
          console.error('Error interceptor: ', err);
        }

        if (err.status === 503) {
          if (!Global.isInMaintenanceMode) {
            Global.isInMaintenanceMode = true;
            // tslint:disable-next-line: deprecation
            this.router.navigate(['/maintenance']);
          }
        } else if (err.status === 401 && !request.url.includes('oauth')) {
          // auto logout if 401 response returned from api
          localStorage.removeItem('currentToken');
          sessionStorage.removeItem('currentToken');

          localStorage.setItem('sessionExpired', 'true');
          // tslint:disable-next-line: deprecation
          location.reload();
        }
        return throwError(err);
      })
    );
  }
}
